import store from '@/store';
import { p2pActions } from '@/store/p2p-slice';

import { handleNewP2Pkeys } from './createP2PKeys';
import { getUUID } from './getUuid';
import { sendP2PSocketData } from './p2pConnection';

export const peerConnectedHandler = async () => {
    store.dispatch(p2pActions.updatePeerFound('Peer Connected'));

    const uuids = await getUUID();

    const { privateKeyStringified, publicKeyStringified } =
        await handleNewP2Pkeys(uuids[0].keypair);

    const isInUploadKeyPage = store.getState().p2pReducer.isInUploadKeyPage;

    if (privateKeyStringified && publicKeyStringified) {
        store.dispatch(
            p2pActions.setP2PKeys({
                JSON_SERVER: publicKeyStringified,
                JSON_USER: privateKeyStringified,
            }),
        );

        if (isInUploadKeyPage) {
            sendP2PSocketData({
                command: 'send_msg',
                data: {
                    client_event: 'init_auth',
                    encrypted_key: publicKeyStringified,
                },
            });
        }
    }
};
